export default "__VITE_ASSET__BsEf5Yt1__"